import React from 'react';

const Loading = () => {

    return (
        // <!-- ========== Start Loading ========== -->
        <div className="preloader preloader2">
            <div className="preloader-item">
                <div className="move"></div>
            </div>
        </div>
        // <!-- ========== End Loading ========== -->
    );

}

export { Loading };
